<agpr-take-over-panel
    [id]="id"
    [header]="'VisibilityIntelligence.querySetup.generateAdditionalQuestionsPanel.header'"
    [ariaLabel]="'VisibilityIntelligence.querySetup.generateAdditionalQuestionsPanel.header'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [maxPanelWidth]="610"
    [minPanelWidth]="610"
    (visibleChange)="close($event)"
>
    <div
        class="agpr-viGenerateAdditionalQuestionsPanel"
        [agprLoading]="isGenerating"
    >
        <p class="agpr-viGenerateAdditionalQuestionsPanel-message">
            {{ 'VisibilityIntelligence.querySetup.generateAdditionalQuestionsPanel.message' | localize }}
        </p>
        <agpr-scroll-panel>
            <div class="agpr-viGenerateAdditionalQuestionsPanel-dimensions">
                @for (dimension of dimensions; track dimension.key) {
                    <div class="agpr-viGenerateAdditionalQuestionsPanel-dimension">
                        <div class="agpr-viGenerateAdditionalQuestionsPanel-dimension-summary">
                            <div class="agpr-viGenerateAdditionalQuestionsPanel-dimension-label">
                                {{ dimension.label | localize }}
                            </div>
                            <div class="agpr-viGenerateAdditionalQuestionsPanel-dimension-count">
                                {{ 'VisibilityIntelligence.querySetup.generateAdditionalQuestionsPanel.existingQuestions' | localize: { count: dimension.existingCount } }}
                            </div>
                        </div>
                        <div class="agpr-viGenerateAdditionalQuestionsPanel-dimension-countInput">
                            <agpr-number-input
                                [id]="id + '_dimension_' + dimension.key + '_count'"
                                [min]="0"
                                [max]="questionCountLimit"
                                [ngModel]="dimension.count"
                                (ngModelChange)="dimension.count = $event; onQuestionCountChange()"
                            ></agpr-number-input>
                        </div>
                    </div>
                }
            </div>
        </agpr-scroll-panel>
        <agpr-vi-active-question-summary
            [id]="id + '_activeQuestionSummary'"
            class="agpr-viQuerySetup-reviewQuestion-activeQuestionSummary"
            [questionsCount]="createdQuestionsCount"
        ></agpr-vi-active-question-summary>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="Core.button.cancel"
            [id]="id + '_cancelButton'"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [label]="'VisibilityIntelligence.querySetup.generateAdditionalQuestionsPanel.actions.generate'"
            [id]="id + '_generateButton'"
            [style]="buttonTypes.primary"
            (click)="generate()"
            [disabled]="!canGenerate || isGenerating"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
